module.exports = __webpack_public_path__ + "img/delete.538d69f6.png";